import { Component } from '@verndale/core';
import Swiper, { Pagination } from 'swiper';

// configure Swiper to use modules
Swiper.use([Pagination]);

class Module extends Component {
  setupDefaults() {
    this.isMobileOrTablet = matchMedia('(max-width: 1279px)');

    this.dom = {
      slider: this.el.querySelector('.media-carousel .swiper-container'),
      sliderNavigation: this.el.querySelector(
        '.media-carousel .media-carousel__navigation'
      ),
      sliderCaption: this.el.querySelector(
        '.media-carousel .media-carousel__caption'
      ),
      sliderFooter: this.el.querySelector(
        '.media-carousel .media-carousel__footer'
      ),
      slides: this.el.querySelectorAll('.media-carousel .swiper-slide')
    };

    this.initSlider();

    if (this.dom.slides && this.dom.slides[0]) {
      const slide = this.dom.slides[0].querySelector(
        '.media-carousel__slide-caption'
      );
      if (slide) {
        this.dom.sliderCaption.innerHTML = slide.innerHTML;
      } else {
        this.dom.sliderCaption.innerHTML = '';
      }
    }
  }

  initSlider() {
    let configPagination = {
        el: this.dom.sliderNavigation,
        clickable: true
      },
      configLoop = true,
      configCenteredSlides = true,
      configSlidesPerView = 1.2;

    if (this.dom.slides && this.dom.slides.length <= 2) {
      if (this.dom.slides.length <= 2) {
        configLoop = false;
        configCenteredSlides = false;
      }
      if (this.dom.slides.length <= 1) {
        configSlidesPerView = 1;
        configPagination = false;
        this.dom.sliderNavigation.style.display = 'none';
      }
    }

    this.swiper = new Swiper(this.dom.slider, {
      slidesPerView: configSlidesPerView,
      centeredSlides: false,
      loop: false,
      spaceBetween: 22,
      threshold: 8,
      watchOverflow: true,
      pagination: configPagination,
      breakpoints: {
        1280: {
          spaceBetween: 32,
          centeredSlides: configCenteredSlides,
          loop: configLoop
        },
        1600: {
          spaceBetween: 40,
          centeredSlides: configCenteredSlides,
          loop: configLoop
        }
      },
      on: {
        init: this.handleInitResize.bind(this),
        resize: this.handleInitResize.bind(this),
        slideChange: swiper => {
          const currentSlide = this.dom.slides[swiper.realIndex];
          const slideCaption = currentSlide.querySelector(
            '.media-carousel__slide-caption'
          );
          if (slideCaption) {
            this.dom.sliderCaption.innerHTML = slideCaption.innerHTML;
          } else {
            this.dom.sliderCaption.innerHTML = '';
          }
        }
      }
    });
  }

  handleInitResize() {
    if (this.dom.sliderFooter) {
      this.dom.sliderFooter.style.width = 'auto';
      if (!this.isMobileOrTablet.matches && this.dom.slides[0]) {
        this.dom.sliderFooter.style.width = this.dom.slides[0].style.width;
        if (this.dom.slides.length === 2) {
          this.dom.sliderFooter.style.marginLeft = 0;
          this.dom.sliderFooter.style.width = '100%';
        }
      }
    }
  }
}

export default Module;
